import { render, staticRenderFns } from "./YearGroup.vue?vue&type=template&id=369440f2&scoped=true&"
import script from "./YearGroup.vue?vue&type=script&lang=js&"
export * from "./YearGroup.vue?vue&type=script&lang=js&"
import style0 from "./YearGroup.vue?vue&type=style&index=0&id=369440f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369440f2",
  null
  
)

export default component.exports